import { downloadBlob, postForFile } from './batch3Api';

export { downloadBlob };

export interface MaReportSummary {
  company: string;
  prior_source: string | null;
}

export interface MaReportInput {
  pnl: File;
  bs: File | null;
  coa: File;
  priorPnl: File | null;
  logo: File | null;
  reportTitle: string;
  clientName: string;
  subClientName: string;
  customNotes: string;
  makePptx: boolean; // standard report only
}

export function generateMaReport(kind: 'standard' | 'monthly', input: MaReportInput) {
  const form = new FormData();
  form.append('pnl_file', input.pnl);
  form.append('coa_file', input.coa);
  if (input.bs) form.append('bs_file', input.bs);
  if (input.priorPnl) form.append('prior_pnl_file', input.priorPnl);
  if (input.logo) form.append('logo_file', input.logo);
  form.append(
    'options',
    JSON.stringify({
      report_title: input.reportTitle,
      client_name: input.clientName,
      sub_client_name: input.subClientName,
      custom_notes: input.customNotes,
      make_pptx: input.makePptx,
    })
  );
  return postForFile<MaReportSummary>(
    kind === 'standard' ? '/ma-report/generate' : '/ma-report-monthly/generate',
    form,
    'MA_report.pdf',
    'Report generation failed'
  );
}

export interface MaReportExcelSummary {
  company: string;
  warnings: string[];
}

export function generateMaReportExcel(yearlyPnl: File, balanceSheets: File[], yearEndDate: string) {
  const form = new FormData();
  form.append('yearly_pnl_file', yearlyPnl);
  balanceSheets.forEach((f) => form.append('bs_files', f));
  form.append('options', JSON.stringify({ ye_date: yearEndDate || null }));
  return postForFile<MaReportExcelSummary>(
    '/ma-report-monthly/excel',
    form,
    'MA_report.xlsx',
    'Excel generation failed'
  );
}
